<template>
  <div class="footer">
    <div class="footerTp">
      <div class="fttpCon clearfix">
        <div class="fttp_li wow fadeInUp">
          <p class="fttp_li_p1">关于五菱新能源</p>
          <div class="fttp_d">
            <div class="fttp_dd">
              <a href="javascript:;" class="fttp_dd_a" @click="toIntro()">公司介绍</a>
            </div>
           
            <div class="fttp_dd">
              <a href="javascript:;" class="fttp_dd_a" @click="toStory()">品牌故事</a>
            </div>
            <div class="fttp_dd">
              <a href="javascript:;" class="fttp_dd_a" @click="toNews1()">资讯中心</a>
            </div>
            <div class="fttp_dd">
              <a href="javascript:;" class="fttp_dd_a" @click="toJoin()">加入我们</a>
            </div>
			 <div class="fttp_dd">
              <a href="javascript:;" class="fttp_dd_a" @click="toRelation()">投资者关系</a>
            </div>
          </div>
        </div>
        <div class="fttp_li wow fadeInUp">
          <p class="fttp_li_p1">资讯中心</p>
          <div class="fttp_dd">
              <a href="javascript:;" class="fttp_dd_a" @click="toNews1()">新闻资讯</a>
            </div>
            <div class="fttp_dd">
              <a href="javascript:;" class="fttp_dd_a" @click="toNews2()">行业资讯</a>
            </div>
        </div>
        <div class="fttp_li wow fadeInUp">
          <p class="fttp_li_p1">菱势服务</p>
          <div class="fttp_d">
            <div class="fttp_dd">
              <a href="javascript:;" class="fttp_dd_a" @click=" toDealer()">菱势线下体验店</a>
            </div>
            <div class="fttp_dd">
              <a href="javascript:;" class="fttp_dd_a" @click=" toSupplier()">特约服务站</a>
            </div>
            <div class="fttp_dd"  @click="toService() ">
              <a href="javascript:;" class="fttp_dd_a">大客户购车</a>
            </div>
          </div>
        </div>
        <div class="fttp_li wow fadeInUp">
          <p class="fttp_li_p1">了解更多</p>
          <div class="fttp_d">
            <div class="fttp_dd"  @click="toCooperate()">
              <a href="javascript:;" class="fttp_dd_a">加盟合作</a>
            </div>
            <div class="fttp_dd"  @click="tocontact()">
              <a href="javascript:;" class="fttp_dd_a">联系我们</a>
            </div>
            <div class="fttp_dd">
              <a href="javascript:;" class="fttp_dd_a" @click="toSer()">服务支持</a>
            </div>
          </div>
        </div>
        <div class="fttp_li wow fadeInUp">
          <p class="fttp_li_p1">尊享热线</p>
          <p class="fttp_li_p2">{{ data.WEB_MOBILE }}</p>
          <div class="fttoadd">
            <p class="fttp_li_p1">联系地址</p>
            <p class="fttp_li_p2"><span class="fttp_li_sp3">{{ data.WEB_ADDRESS }}</span></p>
          </div>
        </div>
      </div>
    </div>
    <div class="footerBt">
      <p class="ftb_p2 wow fadeInUp">
        <span class="ftb_sp">© {{ data.WEB_NAME }}</span><a href="https://beian.miit.gov.cn/" target="_blank"
                     style="color:#9e9e9f" class="ftb_sp"> {{ data.WEB_ICP }}</a>
					 <img src="~@/assets/image/icoo.png" style="width:1%">
					 <a href="https://beian.mps.gov.cn/#/query/webSearch?code=45020002000210" rel="noreferrer" target="_blank" style="color:#9e9e9f">桂公网安备45020002000210</a>
      </p>
    </div>
  </div>
</template>

<script>
import { WOW } from 'wowjs'
  export default {
    name: 'foot',
    data () {
      return {
        data:[],
      }
    },
    computed: {
    },
    watch: {
    },
    mounted () {
      // 在项目加载完成之后初始化wow
      this.$nextTick(() => {
        let wow = new WOW({
          live: false,
        })
        wow.init()
      })

      this.$post("/api/config", {
        code:"WEB_"
      }).then((resp) => {
          if (resp.code == 1) {
              this.data = resp.data

              var obj=document.getElementsByTagName("meta")[9];
              obj.content = resp.data.WEB_SEO_KEY;

              var obj=document.getElementsByTagName("meta")[10];
              obj.content = resp.data.WEB_SEO_DESP;
          }
      })
    },
    methods: {
      toIntro(){
        this.$router.push({
            name: 'introduce',
            query: {
            },
          })
      },
      toRelation(){
        this.$router.push({
            name: 'relation1',
            query: {
            },
          })
      },
      toStory(){
        this.$router.push({
            name: 'story',
            query: {
            },
          })
      },
      toNews(){
        this.$router.push({
            name: 'news',
            query: {
            },
          })
      },
      toNews1(){
        this.$router.push({
            name: 'news1',
            query: {
            },
          })
      },
      toNews2(){
        this.$router.push({
            name: 'news2',
            query: {
            },
          })
      },
      toJoin(){
        this.$router.push({
            name: 'join',
            query: {
            },
          })
      },
       toSer(){
        this.$router.push({
            name: 'ser',
            query: {
            },
          })
      },
      toConsultation(){
        this.$router.push({
            name: 'consultation',
            query: {
            },
          })
      },
      toCooperate(){
        this.$router.push({
            name: 'cooperate',
            query: {
            },
          })
      },
      tocontact(){
        this.$router.push({
            name: 'contactUs',
            query: {
            },
          })
      },
      toService(){
        this.$router.push({
            name: 'service',
            query: {
            },
          })
      },
      toproduct1(){
        this.$router.push({
            name: 'product1',
            query: {
            },
          })
      },
      toproduct2(){
        this.$router.push({
            name: 'product2',
            query: {
            },
          })
      },
      toproduct3(){
        this.$router.push({
            name: 'product3',
            query: {
            },
          })
      },
      toproduct4(){
        this.$router.push({
            name: 'product4',
            query: {
            },
          })
      },
      toNothig(){
        this.$router.push({
            name: 'demo',
            query: {
            },
          })
      },
      toDealer(){
        this.$router.push({
            name: 'dealer',
            query: {
            },
          })
      },
      toSupplier(){
        this.$router.push({
            name: 'supplier',
            query: {
            },
          })
      },
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/foot.vue